// extracted by mini-css-extract-plugin
export default {"dialog":"SD7LCSZ4lgkiTQzV","text":"SwVDLR4MXm0KPr5V","footer":"Rs8DiGzHYgoAGXIF","checkbox":"UB0QkhjCIugYyFfL"};